import { Box, Stack, Typography } from '@mui/material';

/**
 * Uppercase label + truncated value pair used inside `PreviewCard` to
 * surface a single field. `mono` switches the value to monospace for
 * identifier-like values (fiscal id, IBAN, SIM serial, etc.). `labelWidth`
 * lets the caller widen the label column when the longest label needs
 * more room — defaults to 56 which fits "EMAIL", "PHONE", "OWNER", etc.
 */
const PreviewRow = ({ label, value, mono, labelWidth = 56 }) => (
  <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: 'uppercase', letterSpacing: 0.6, fontWeight: 600, minWidth: labelWidth }}
    >
      {label}
    </Typography>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      {typeof value === 'string' ? (
        <Typography
          variant="body2"
          sx={{
            fontFamily: mono ? 'monospace' : undefined,
            fontWeight: 500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {value}
        </Typography>
      ) : (
        value
      )}
    </Box>
  </Stack>
);

export default PreviewRow;
